export const ScanApiConstant = { 
    TAKEN_PREVIEW: "TAKEN_PREVIEW", 
    INIT_PREVIEW: "INIT_PREVIEW", 
    TAKING_PREVIEW: "TAKING_PREVIEW", 
    REGION_SELECTION_DONE: "SELECTION_DONE", 
    SELECTION_CANCELLED: "SELECTION_CANCELLED", 
    SELECTION_CONFIRMED: "SELECTION_CONFIRMED", 
    SPEED_CHANGE: "SPEED_CHANGE", 
    SPEED_CHANGE_FOR_ALL_SLOTS: "SPEED_CHANGE_FOR_ALL_SLOTS", 
    NAME_CHANGE: "NAME_CHANGE", 
    START_LIVE_VIEW: "START_LIVE_VIEW",
    STOP_LIVE_VIEW: "STOP_LIVE_VIEW",
    UPDATE_LIVE_VIEW: "UPDATE_LIVE_VIEW", 
    FAILED_IN_LIVE_VIEW_UPDATE: "FAILED_IN_LIVE_VIEW_UPDATE", 
    ERRORED_WHILE_TAKING_PREVIEW : "ERRORED_OUT_WHILE_TAKING_PREVIEW", 
    ERRORED_WHILE_CONFIRMING_SELECTION : "ERRORED_WHILE_CONFIRMING_SELECTION", 

    SET_DO_TILING_ONLY: "SET_DO_TILING_ONLY", 
    UNSET_DO_TILING_ONLY: "UNSET_DO_TILING_ONLY", 

    SPECIMEN_TYPE_CHANGE: "SPECIMEN_TYPE_CHANGE",
    OBJECTIVE_TYPE_CHANGE: "OBJECTIVE_TYPE_CHANGE", 
    SCAN_OUTPUT_FORMAT_CHANGE: "SCAN_OUTPUT_FORMAT_CHANGE"
 }